import { Route } from "react-router-dom";
import { Dashboard } from "./component/Dashboard/Dashboard";
import { Diagnosis } from "./component/Diagnosis/Diagnosis";
import { Prescription } from "./component/Prescription/Prescription";
import Procedures from "./component/Procedures/Procedures";
import Consultation from "./component/Consultation/Consultation";
import { Billing } from "./component/Billing/Billing";
import { Pharmacy } from "./component/Billing/Pharmacy";
import PmsDashboard from "./Pages/Pmc/Dashboard/PmsDashboard";
import Rxdocs from "./Pages/Pmc/Rxdocs/Rxdocs";
import Dispensed from "./Pages/Pmc/Dispensed/Dispensed";
import PmsPendingRx from "./Pages/Pmc/Pendingrx/Pendingrx";
import PmsPricing from "./component/Pmc/Pricing/Pricing";
import PmsDispensed from "./component/Pmc/Dispensed/Dispensed";
const Router = ({
  selectedBanner,
  setSelectedBanner,
  verticalCreative,
  reactCreative,
  horizontalCreative,
  popupCreative,
}) => {
  return (
    <>
      <Route
        path="/People/dashboard"
        component={(props) => (
          <Dashboard {...props} verticalCreative={verticalCreative} reactCreative={reactCreative} />
        )}
      />
      <Route
        path="/People/Consultation"
        component={(props) => (
          <Consultation
            {...props}
            selectedBanner={selectedBanner}
            setSelectedBanner={setSelectedBanner}
            reactCreative={reactCreative}
            verticalCreative={verticalCreative}
          />
        )}
      />
      <Route
        path="/People/Procedures"
        component={(props) => (
          <Procedures
            {...props}
            selectedBanner={selectedBanner}
            setSelectedBanner={setSelectedBanner}
            reactCreative={reactCreative}
            verticalCreative={verticalCreative}
          />
        )}
      />
      <Route
        path="/People/Diagnosis"
        component={(props) => (
          <Diagnosis
            {...props}
            selectedBanner={selectedBanner}
            setSelectedBanner={setSelectedBanner}
            reactCreative={reactCreative}
            verticalCreative={verticalCreative}
          />
        )}
      />
      <Route
        path="/People/Prescription"
        component={(props) => (
          <Prescription
            {...props}
            selectedBanner={selectedBanner}
            setSelectedBanner={setSelectedBanner}
            reactCreative={reactCreative}
            verticalCreative={verticalCreative}
          />
        )}
      />
      <Route
        path="/People/billing"
        component={(props) => (
          <Billing
            {...props}
            verticalCreative={verticalCreative}
            reactCreative={reactCreative}
          />
        )}
      />
      <Route path="/People/Pharmacy" component={(props) => (
        <Pharmacy
          {...props}
          verticalCreative={verticalCreative}
          reactCreative={reactCreative}
        />
      )} />
      <Route path="/Pmc/dashboard" component={PmsDashboard}/>
      <Route path="/Pmc/pendingrx" component={PmsPendingRx}/>
      <Route path="/Pmc/rxdocs" component={Rxdocs}/>
      <Route path="/Pmc/pricing" component={PmsPricing}/>
      <Route path="/Pmc/dispensed" component={PmsDispensed}/>

    </>
  );
};
export default Router;
